import axios from 'axios';

export default {
  getSalesByRep(params) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/sales/reps", {params})
      .then(response=>{
        return response.data;
      })
  },
  getSalesByProductType(params) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/sales/product-types", {params})
      .then(response=>{
        return response.data;
      })
  },
  getSalesByProductSpecificType(params) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/sales/product-specific-types", {params})
      .then(response=>{
        return response.data;
      })
  },
  getSalesByTerritories(params) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/sales/territories", {params})
      .then(response=>{
        return response.data;
      })
  },
  getSalesByRebateTypes (params) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/sales/rebate-types", {params})
      .then(response=>{
        return response.data;
      })
  },
  getSalesByFeeTypes (params) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/sales/fees-types", {params})
      .then(response=>{
        return response.data;
      })
  },
  getSalesByCustomerClasses(params) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/sales/customer-classes", {params})
      .then(response=>{
        return response.data;
      })
  },
  getSalesByProviders(params) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/sales/providers", {params})
      .then(response=>{
        return response.data;
      })
  },
  getSalesByPriceRange(params) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/sales/price-ranges", {params})
      .then(response=>{
        return response.data;
      })
  },
  getCustomerSales(params) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/sales/customers", {params})
      .then(response=>{
        return response.data;
      })
  },
  getSalesEvolution(params) {
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/v1/admin/sales/evolution", {params})
      .then(response=>{
        return response.data;
      })
  },
  fetchSalesByProduct(puid, format=null){
    let params  ={
      puid,
      format
    }
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sales", {params})
      .then(response=>{
        return response.data;
      })
  },
  // DEPRECATED use fetchSalesByPuid instead
  fetchSalesByProduct(productId, inventoryId, format=null){
    let params  ={
      productId,
      inventoryId,
      format
    }
    // console.log("SalesORderAPI DELETE : ", salesOrderId);
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sales", {params})
      .then(response=>{
        return response.data;
      })
  },
  getReportInfo(reportCode, params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sales/reports/"+reportCode, {params})
      .then(response=>{
        return response.data;
      })
  },
  getReportInfoV2(reportCode, params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/latest/admin/sales/reports/"+reportCode, {params})
      .then(response=>{
        return response.data;
      })
  },
  downloadReservationUpcomingOrderReport(params, filename){
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/api/latest/admin/reservations/reports";

    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob([response.data]));
           const link = document.createElement('a');
           link.href = url;
           // console.log(response);
           link.setAttribute('download', filename); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
  downloadTransactionSalesReport(params, filename){
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/api/latest/admin/sales-orders";
    
    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
          let url = null;

          if (params.format === 'CSV') {
            url = window.URL.createObjectURL(new Blob(['\uFEFF', response.data], { type: 'text/csv; charset=utf-8' }));
          } else {
            url = window.URL.createObjectURL(new Blob([response.data]));
          }
          
           const link = document.createElement('a');
           link.href = url;
           // console.log(response);
           link.setAttribute('download', filename); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
  downloadSalesReport(reportCode, filename, params){
    let url = process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/API/sales/reports/"+reportCode;

    // console.log("downloadSalesOrderReport : ", filename);

    return axios({
          url: url,
          method: 'GET',
          params,
          responseType: 'blob', // important
        }).then((response) => {
           const url = window.URL.createObjectURL(new Blob(['\uFEFF', response.data], { type: 'text/csv; charset=utf-8' }));
           const link = document.createElement('a');
           link.href = url;
           // console.log(response);
           link.setAttribute('download', filename); //or any other extension
           document.body.appendChild(link);
           link.click();
        });
  },
}
